export default __webpack_public_path__ + "static/retratosfantasmas-253603a6a2f2b6c5c51a9a62cd41563a.jpg";